import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
  TextField,
  NumberField,
  Paragraph,
  Dropdown,
  DateTime,
  Checkbox,
  Toggle,
  RadioButton,
  Link,
} from "./CustomizedControls";
import Loader from "./Loader";
import Table, { TableRow } from "../../component/table";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBookingByCompanyId,
  getAllBookingName,
} from "../../redux/actions/bookingtemplate";
import { getAssets } from "../../redux/actions/asset";
import { getConfigurationData } from "../../redux/actions/configurationAction";
import { createBookings, uploadBookingFile } from "../../redux/actions/booking";
import {
  GET_ALL_BOOKING_NAME,
  RESET_SAVE_TEMPORARY_DATA,
  SAVE_TEMPORARY_DATA,
} from "../../redux/constants";
import Select, { components } from "react-select";
import "../../css/theme.css";
import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { getCollaboratorByType } from "../../redux/actions/user";
import { Customer, Super_Admin } from "../../constant/AuthenticationConstant";
import { sanitizeInput } from "../../utils";
const { MenuList } = components;

function CreateBooking() {
  const [customFieldMaxRowSize, setCustomFieldMaxRowSize] = useState();
  const [refnum, setRefNum] = useState("");
  const [configid, setConfigId] = useState(null);
  const [newjson, setNewJson] = useState([]);
  const [assettype, setAssetType] = useState("");
  const [quantity, setQuantity] = useState("");
  const [remarks, setRemarks] = useState("");
  const [bookingtempid, setBookingTempId] = useState(null);
  const [booking, setBooking] = useState("");
  const [workflow, setWorkflow] = useState("");
  const [customer, setCustomer] = useState("");
  const [assettypequant, setAssetTypeQuant] = useState([]);
  const [tabledata, setTableData] = useState([]);
  const [allbookingtemp, setAllBookingTemp] = useState([]);
  const [allconfigs, setAllConfigs] = useState([]);
  const [allcustomers, setAllCustomers] = useState([]);
  const [allassets, setAllAssets] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { bookingTemplateArr } = useSelector((state) => state.bookingTemplate);
  const { assetList } = useSelector((state) => state.assets);
  const { configurationData } = useSelector(
    (state) => state.configurationReducer
  );
  const { collaboratorList } = useSelector((state) => state.user);

  const { saveData, tempPageName } = useSelector(
    (state) => state.tempWindowsData
  );
  const { type } = useSelector((state) => state.auth);

  // Creating reference for parent div of custom rows
  const customRowsParentDiv = useRef();

  // Creating state for loader
  const [loaderOpen, setLoaderOpen] = useState(false);
  const [validation, setValidation] = useState([]);
  const [fileupload, setFileUpload] = useState([]);
  const { v4: uuidv4 } = require("uuid");
  const [upload, setUpload] = useState([]);
  useEffect(() => {
    if (bookingTemplateArr?.length !== 0) {
      bookingTemplateArr?.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    }
  }, [bookingTemplateArr]);

  useEffect(() => {
    if (bookingTemplateArr?.length > 0 || Object.keys(saveData).length === 0) {
      var arr = [];
      bookingTemplateArr?.map((ele) => {
        const type = ele.component?.type;
        arr.push({
          booking_template_custom_field_id:
            ele.booking_template_custom_field_id,
          component_id: ele.component_id,
          field_name: ele.component?.label,
          field_value:
            type === "toggle" || type === "check box"
              ? JSON.stringify(ele.component.is_check_by_default)
              : null,
          required: ele.is_required,
        });
      });
      setNewJson(arr);
    }
  }, [bookingTemplateArr]);

  useEffect(() => {
    dispatch({
      type: GET_ALL_BOOKING_NAME,
      payload: [],
    });
  }, []);

  useEffect(() => {
    const request = {
      onError: () => {},
    };
    dispatch(
      getAllBookingByCompanyId((res) => {
        if (res.status === 1) {
          const result = res.data;
          const arr = [];
          result.data.map((item) => {
            arr.push({
              value: item.booking_template_name,
              label: item.booking_template_name,
              id: item.booking_template_id,
            });
          });
          setAllBookingTemp(arr);
        }
      })
    );
    dispatch(getConfigurationData(request));
    dispatch(getAssets((res) => {}));
    dispatch(getCollaboratorByType(Customer));
  }, []);

  useEffect(() => {
    if (configurationData?.data?.length !== 0) {
      const arr = [];
      configurationData?.data?.map((item) => {
        arr.push({
          value: item.configuration_id,
          label: item.configuration_name,
        });
      });
      setAllConfigs(arr);
    }
  }, [configurationData]);

  useEffect(() => {
    if (assetList?.data?.length !== 0) {
      const arr = [];
      assetList?.data?.map((item) => {
        arr.push({
          value: item.asset_type_id,
          label: item.asset_type,
        });
      });
      setAllAssets(arr);
    }
  }, [assetList]);

  useEffect(() => {
    if (collaboratorList?.data?.length !== 0) {
      const arr = [];
      collaboratorList?.data?.map((item) => {
        arr.push({
          value: item.collaborator_id,
          label: item.name,
        });
      });
      setAllCustomers(arr);
    }
  }, [collaboratorList]);

  useEffect(() => {
    if (tempPageName === "bookings") {
      setRefNum(saveData.refnum);
      setBookingTempId(saveData.bookingtempid);
      if (saveData.bookingtempid !== "") {
        dispatch(getAllBookingName(saveData.bookingtempid, (res) => {}));
      }
      setBooking(saveData.booking);
      setNewJson(saveData.newjson);
      setAssetTypeQuant(saveData.assettypequant);
      setConfigId(saveData.configid);
      setTableData(saveData.tabledata);
      setWorkflow(saveData.workflow);
      setCustomer(saveData.customer);
      setAssetType(saveData.assettype);
      setQuantity(saveData.quantity);
      setRemarks(saveData.remarks);
      setUpload(saveData.upload);
      setFileUpload(saveData.fileupload);
    }
  }, [saveData, tempPageName]);

  const getBookingCustomFields = (e) => {
    setBooking(e);
    const id = e === null ? null : e.id;
    if (id !== "" && id !== null) {
      setBookingTempId(id);
      dispatch(getAllBookingName(id, (res) => {}));
    } else {
      dispatch({
        type: GET_ALL_BOOKING_NAME,
        payload: [],
      });
      setBookingTempId(null);
    }
  };

  const getConfigId = (e) => {
    setWorkflow(e);
    const id = e === null ? null : e.value;
    setConfigId(id);
  };

  const getCustomerId = (e) => {
    setCustomer(e);
  };

  const faqs = [
    {
      question: "Assets and Quantities",
      answer:
        "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
    },
  ];

  const SubmitBooking = () => {
    const errorArray = newjson.map((element, index) => {
      return element.required && !element.field_value
        ? element.booking_template_custom_field_id
        : null;
    });

    setValidation(errorArray);
    if (errorArray.some((element) => typeof element === "string")) return;

    setLoaderOpen(true);
    dispatch(
      createBookings(
        bookingtempid,
        configid,
        refnum.trim(),
        newjson,
        tabledata,
        customer?.value,
        (res) => {
          setLoaderOpen(false);
          if (res.status === 1) {
            let activity_assignment_id = res.data;
            if (tempPageName === "bookings") {
              dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
            }
            swal({
              content: (
                <CustomeModal
                  type="success"
                  title="Success!"
                  content={`Booking created successfully.`}
                  event="click"
                  onClick={() => {
                    if (activity_assignment_id !== undefined) {
                      if (upload.length > 0) {
                        let formdata = new FormData();
                        for (const item of upload) {
                          formdata.append("file", item);
                        }
                        dispatch(
                          uploadBookingFile(
                            activity_assignment_id,
                            formdata,
                            (res) => {}
                          )
                        );
                      }
                      navigate(`/assignment/assign/${activity_assignment_id}`);
                    }
                  }}
                />
              ),
              buttons: false,
              closeOnClickOutside: false,
              closeOnEsc: false,
            });
          } else {
            swal({
              content: (
                <CustomeModal
                  type="error"
                  title="Error!"
                  content={
                    res.message === "Duplicate entry"
                      ? "Internal booking ID already exist with this name. Please use any other name."
                      : res.message
                  }
                />
              ),
              buttons: false,
              closeOnClickOutside: false,
              closeOnEsc: false,
            });
          }
        }
      )
    );
  };

  const renderInput = (input, index, validation) => {
    const isMandatory = input.is_required;
    var value;
    if (saveData.newjson?.length > 0) {
      newjson.forEach((ele) => {
        if (ele.field_id === input.component.component_id) {
          value = ele.field_value;
        }
      });
    }

    const gridPosition = JSON.parse(input.grid_position);
    const inputWidth = gridPosition?.w ? gridPosition.w : 2;
    const gridWidthClass = `${
      parseInt(inputWidth) !== 4 ? (parseInt(inputWidth) / 4) * 100 : 100
    }`;
    const props = {
      isMandatory,
      index,
      input,
      value,
      validation,
      handleChange: handleChange,
      gridWidthClass,
    };
    if (input.component?.type === "text") {
      return <TextField {...props} />;
    } else if (input.component?.type === "toggle") {
      return <Toggle {...props} />;
    } else if (input.component?.type === "radio group") {
      return <RadioButton {...props} />;
    } else if (input.component?.type === "link") {
      return <Link {...props} />;
    } else if (input.component?.type === "check box") {
      return <Checkbox {...props} />;
    } else if (input.component?.type === "dropdown") {
      return <Dropdown {...props} />;
    } else if (input.component?.type === "date/time") {
      return <DateTime {...props} />;
    } else if (input.component?.type === "paragraph") {
      return <Paragraph {...props} />;
    } else if (input.component?.type === "number") {
      return <NumberField {...props} />;
    }
  };

  const handleChange = (e, id, type) => {
    if (type === "dropdown") {
      var value = e === null ? null : e.value;
    } else if (type === "checkbox") {
      var value = JSON.stringify(e.target.checked);
    } else {
      var value = type === "datetime" ? e[0] : sanitizeInput(e.target.value);
    }
    newjson.map((ele, index) => {
      if (ele.booking_template_custom_field_id === id) {
        let copyjson = [...newjson];
        copyjson[index].field_value = value;
        setNewJson(copyjson);
      }
    });
  };
  const setTypeAndQuantity = (e) => {
    const { name, value } = e.target;
    setAssetTypeQuant({ ...assettypequant, [name]: value });
    if (name === "quantity") {
      setQuantity(value);
    } else {
      setRemarks(value);
    }
  };

  const removeItem = (index) => {
    const newArray = [
      ...tabledata.slice(0, index),
      ...tabledata.slice(index + 1),
    ];
    setTableData(newArray);
  };

  const handleNavigation = (type) => {
    const payload = {
      path: location.pathname,
      tempPageName: "bookings",
      saveData: {
        booking,
        bookingtempid,
        //enableqty,
        assettypequant,
        workflow,
        customer,
        configid,
        refnum,
        newjson,
        assettype,
        quantity,
        remarks,
        tabledata,
        upload,
        fileupload,
      },
    };

    dispatch({ type: SAVE_TEMPORARY_DATA, payload });

    if (type === "bookingtemp") {
      navigate("/booking/design/overview", { state: true });
    } else if (type === "configname") {
      navigate("/configuration/create");
    } else if (type === "asset_type") {
      navigate("/assets", { state: true });
    } else {
      navigate("/users", { state: 3 });
    }
  };

  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      <div
        className="menu-list !text-[--bg-color-500]"
        onClick={(e) => {
          e.stopPropagation();
          handleNavigation(props.selectProps.name);
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs text-[--bg-color-500]"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        <span className="!text-[--bg-color-500]">
          {props.selectProps.name === "bookingtemp"
            ? "Create New Booking Template"
            : props.selectProps.name === "configname"
            ? "Create New Workflow"
            : props.selectProps.name === "asset_type"
            ? "Create New Asset"
            : "Create New Customer"}
        </span>
      </div>
    </MenuList>
  );
  const uploadFile = (e) => {
    setLoaderOpen(true);
    for (const item of e) {
      let fileName = "";
      var filetype = item.name.split(".").pop();
      fileName = item.name;
      const type = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpeg",
        "jpg",
        "png",
        "bmp",
        "txt",
      ];
      const maxFileSize = 4 * 1024 * 1024;
      if (item.size > maxFileSize) {
        setLoaderOpen(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} file exceeds upload limit of 4 MB.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      if (!type.includes(filetype.toLowerCase())) {
        setLoaderOpen(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} must be among these pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, txt.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      setFileUpload((prev) => [
        ...prev,
        {
          activity_file_upload_id: uuidv4(),
          file_name: fileName,
        },
      ]);
    }
    setUpload((prev) => {
      return [...prev, ...e];
    });
    setLoaderOpen(false);
  };

  useEffect(() => {
    if (bookingTemplateArr?.length > 0) {
      const lastCustomField = JSON.parse(
        bookingTemplateArr[bookingTemplateArr?.length - 1].grid_position
      );
      const highestRow = lastCustomField.y;
      setCustomFieldMaxRowSize(highestRow);
    }
  }, [bookingTemplateArr]);

  return (
    <div class="block w-full sm:block min-h-100">
      <form
        className="flex-auto pb-10"
        onSubmit={(e) => {
          e.preventDefault();
          var allowed = true;
          newjson.map((ele) => {
            if (
              ele.field_name === "datetime" &&
              ele.field_value === "" &&
              ele.is_required
            ) {
              swal({
                content: (
                  <CustomeModal
                    type="error"
                    title="Error!"
                    content={`Datetime field is required and it cannot be empty`}
                  />
                ),
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              });
              allowed = false;
            }
          });
          if (allowed) {
            if (tabledata.length === 0) {
              swal({
                content: (
                  <CustomeModal
                    type="confirm"
                    title="Proceed without assets?"
                    content={`Do you want to create the booking without adding assets?`}
                    onClick={() => SubmitBooking()}
                    buttonText="Create"
                  />
                ),
                buttons: false,
                closeOnClickOutside: false,
                closeOnEsc: false,
              });
            } else {
              SubmitBooking();
            }
          }
        }}
      >
        <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-2 sm:inline-block p-[4px] rounded transition-all">
          <label for="assets" className="mb-1">
            Internal Booking ID
            <span className="text-rose-500">*</span>
          </label>
          <br />
          <input
            type="text"
            name="referencenum"
            id="reference-num"
            class="form-input w-full"
            placeholder="Enter Internal Reference Number"
            value={refnum}
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              setRefNum(value);
            }}
            required
          />
        </div>

        <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-2 sm:inline-block p-[4px] rounded transition-all">
          <label for="customer" className="mb-1">
            Customer
          </label>
          <br />
          <Select
            className="basic-single text-sm unresetText"
            classNames={{
              option: (style) => {
                return `${
                  style.isSelected && "!bg-[--bg-color-500] !text-white"
                } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
              },
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]"
                    : "!border-slate-200 hover:!border-gray-300"
                }}`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            isClearable={true}
            classNamePrefix="select"
            name="customername"
            options={allcustomers}
            value={customer}
            placeholder="Select Customer"
            onChange={(e) => getCustomerId(e)}
            components={
              type === Super_Admin ? { MenuList: CustomMenuList } : {}
            }
          />
        </div>
        <br />
        <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-2 sm:inline-block p-[4px] rounded transition-all">
          <label for="assets" className="mb-1">
            Booking Template<span className="text-rose-500">*</span>
          </label>
          <br />
          <Select
            className="basic-single text-sm unresetText"
            classNames={{
              option: (style) => {
                return `${
                  style.isSelected && "!bg-[--bg-color-500] !text-white"
                } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
              },
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            isClearable={true}
            classNamePrefix="select"
            name="bookingtemp"
            options={allbookingtemp}
            value={booking}
            placeholder="Select Booking Template"
            onChange={(e) => getBookingCustomFields(e)}
            components={{ MenuList: CustomMenuList }}
            required
          />
        </div>
        <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-2 sm:inline-block p-[4px] rounded transition-all">
          <label for="assets" className="mb-1">
            Workflow
          </label>
          <br />
          <Select
            className="basic-single text-sm unresetText"
            classNames={{
              option: (style) => {
                return `${
                  style.isSelected && "!bg-[--bg-color-500] !text-white"
                } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
              },
              control: (style) => {
                return `!border !shadow-sm ${
                  style.isFocused
                    ? "!border-[--bg-color-300]/50"
                    : "!border-slate-200 hover:!border-gray-300"
                }`;
              },
              container: (style) => {
                return "!h-[37.5px] !font-inter !text-sm";
              },
              menuList: (style) => {
                return `!max-h-[200px]`;
              },
            }}
            isClearable={true}
            classNamePrefix="select"
            name="configname"
            options={allconfigs}
            value={workflow}
            placeholder="Select Workflow"
            onChange={(e) => getConfigId(e)}
            // onChange={handleInput}
            components={{ MenuList: CustomMenuList }}
          />
        </div>

        {customFieldMaxRowSize?.toString() &&
          bookingTemplateArr?.length > 0 && (
            <div ref={customRowsParentDiv}>
              {bookingTemplateArr?.map((customeComponent, index) => {
                const filteredComponentList = bookingTemplateArr?.filter(
                  (element) => JSON.parse(element.grid_position).y === index
                );

                if (index <= customFieldMaxRowSize) {
                  return (
                    <div className="flex flex-wrap">
                      {filteredComponentList.map((comp, indexNumber) => {
                        return renderInput(
                          comp,
                          comp.booking_template_custom_field_id,
                          validation
                        );
                      })}
                    </div>
                  );
                }
              })}
            </div>
          )}

        <div className="px-1 divide-y divide-gray-900/10">
          <dl className="mt-6 space-y-6 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question}>
                {({ open }) => (
                  <>
                    <dt className="py-5">
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                        <span className="text-base font-semibold leading-7">
                          {faq.question}
                        </span>
                        <span className="ml-6 flex h-7 items-center">
                          {!open ? (
                            <ChevronUpIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          ) : (
                            <ChevronDownIcon
                              className="h-6 w-6"
                              aria-hidden="true"
                            />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    {!open && (
                      <>
                        <div className="w-full flex justify-between space-x-2 pt-2">
                          <div className="w-1/2">
                            <h1 className="text-2xl font-semibold md:text-base md:font-medium">
                              Asset Type
                            </h1>
                            <Select
                              className="basic-single text-sm unresetText"
                              classNames={{
                                option: (style) => {
                                  return `${
                                    style.isSelected && "!bg-[--bg-color-500] !text-white"
                                  } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
                                },
                                control: (style) => {
                                  return `!border !shadow-sm ${
                                    style.isFocused
                                      ? "!border-[--bg-color-300]/50"
                                      : "!border-slate-200 hover:!border-gray-300"
                                  }`;
                                },
                                container: (style) => {
                                  return "!h-[37.5px] !font-inter !text-sm";
                                },
                                menuList: (style) => {
                                  return `!max-h-[200px]`;
                                },
                              }}
                              isClearable
                              classNamePrefix="select"
                              name="asset_type"
                              id="asset-type"
                              value={assettype}
                              placeholder="Select Asset type"
                              options={allassets}
                              onChange={(e) => {
                                setAssetType(e);
                                const value = e === null ? null : e.value;
                                const label = e === null ? null : e.label;
                                setAssetTypeQuant({
                                  ...assettypequant,
                                  asset_type: label,
                                  asset_type_id: value,
                                });
                              }}
                              components={
                                type === Super_Admin
                                  ? { MenuList: CustomMenuList }
                                  : {}
                              }
                            />
                          </div>
                          <div className="w-1/5">
                            <h1 className="text-2xl font-semibold md:text-base md:font-medium">
                              Quantity
                            </h1>
                            <input
                              type="number"
                              name="quantity" //"qty"
                              id="qty" //"quant"
                              min={0}
                              onInput={(e) => {
                                e.target.value = Math.abs(e.target.value);
                              }}
                              value={quantity}
                              placeholder="Enter Quantity"
                              className="form-input w-full"
                              onChange={(e) => {
                                setTypeAndQuantity(e);
                              }}
                            />
                          </div>
                          <div className="w-1/5">
                            <h1 className="text-2xl font-semibold md:text-base md:font-medium">
                              Remarks
                            </h1>
                            <input
                              type="text"
                              name="remarks" //"qty"
                              id="remarks" //"quant"
                              value={remarks}
                              placeholder="Enter Remarks"
                              className="form-input w-full"
                              onChange={(e) => {
                                setTypeAndQuantity(e);
                              }}
                            />
                          </div>
                          <div className="pt-6 pr-1">
                            <button
                              type="button"
                              className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white cursor-pointer"
                              onClick={() => {
                                var asset =
                                  document.getElementById("asset-type")
                                    .lastChild.value;
                                var qty = document.getElementById("qty").value;
                                if (asset !== "" && qty !== "" && qty > 0) {
                                  setTableData([...tabledata, assettypequant]);
                                  //document.getElementById("asset-type").value = "";
                                  setAssetType("");
                                  setQuantity("");
                                  setRemarks("");
                                  document.getElementById("qty").value = "";
                                  setAssetTypeQuant([]);
                                  // document.getElementById("quant").value = "";
                                } else {
                                  swal({
                                    content: (
                                      <CustomeModal
                                        type="error"
                                        title="Error!"
                                        content={`Something went wrong. Asset_type and quantity cannot be empty. Quantity must be greater than 0`}
                                      />
                                    ),
                                    buttons: false,
                                    closeOnClickOutside: false,
                                    closeOnEsc: false,
                                  });
                                }
                              }}
                            >
                              Add
                            </button>
                          </div>
                        </div>
                        <div className="overflow-x-auto shadow-lg rounded border mt-10 mb-10">
                          <Table
                            heads={[
                              {
                                headName: "Asset Type",
                                isSort: false,
                                value: "Asset Type",
                              },
                              {
                                headName: "Quantity",
                                isSort: false,
                                value: "Quantity",
                              },
                              {
                                headName: "Remarks",
                                isSort: false,
                                value: "Remarks",
                              },
                              {
                                headName: "Actions",
                                isSort: false,
                                value: "Actions",
                              },
                            ]}
                            hClass="text-xs font-semibold uppercase text-slate-500 bg-slate-50 border-t border-b border-slate-200"
                            bClass="text-sm divide-y divide-slate-200"
                            thClass="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap text-left font-semibold "
                          >
                            {tabledata.map(
                              ({ asset_type, quantity, remarks }, i) => {
                                //uom, qty
                                return (
                                  <TableRow
                                    key={i}
                                    row={{ asset_type, quantity, remarks }} //uom, qty
                                    prefix={<label title="Select"></label>}
                                    trClass="odd:bg-white"
                                    tdClass="first:flex first:pl-0 pl-3 items-center font-medium whitespace-nowrap m-4"
                                  >
                                    <td className="first:flex items-center font-medium whitespace-nowrap pl-3 ">
                                      <button
                                        type="button"
                                        className="!bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white rounded-lg px-1 py-1"
                                        onClick={() => {
                                          // removeItem(i);
                                          swal({
                                            content: (
                                              <CustomeModal
                                                type="delete"
                                                title="Are you sure?"
                                                content={`All of your data will be permanently removed from our servers forever. This action cannot be undone.`}
                                                onDelete={() => removeItem(i)}
                                              />
                                            ),
                                            buttons: false,
                                            closeOnClickOutside: false,
                                            closeOnEsc: false,
                                          });
                                        }}
                                      >
                                        Delete
                                      </button>
                                    </td>
                                  </TableRow>
                                );
                              }
                            )}
                          </Table>
                        </div>
                      </>
                    )}
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
        <div className="w-full sm:w-full pb-5 bg-white rounded-md">
          <div className="w-1/2 my-2 px-1">
            <span className="text-base text-slate-800 font-semibold leading-7">
              Document Upload
            </span>
            <div
              className="h-[35px] text-sm bg-white rounded-md flex items-center justify-between cursor-pointer"
              type="button"
              onClick={(e) => {
                document.getElementById("booking-upload").click();
                document.getElementById("booking-upload").value = null;
              }}
            >
              Select file to upload
              <p
                className={`text-sm leading-3 font-semibold tracking-tight text-[--bg-color-500]`}
              >
                Select
              </p>
            </div>
            <div>
              {fileupload.map((ele, index) => {
                return (
                  <div
                    className="h-[35px] bg-white rounded-md flex items-center justify-between cursor-pointer"
                    type="button"
                    onClick={(e) => {
                      let index = fileupload.findIndex(
                        (ele) => ele.activity_file_upload_id === e.target.id
                      );
                      setFileUpload(
                        fileupload.filter(
                          (ele) => ele.activity_file_upload_id !== e.target.id
                        )
                      );
                      let name = fileupload[index].file_name;
                      setUpload(upload.filter((ele) => ele.name !== name));
                    }}
                  >
                    {ele.file_name}
                    <span
                      id={ele.activity_file_upload_id}
                      name={ele.file_name}
                      className={`text-xs leading-3 font-semibold tracking-tight text-[#EB5757]`}
                    >
                      Remove
                    </span>
                  </div>
                );
              })}
            </div>
            <input
              id="booking-upload"
              type="file"
              onChange={(e) => {
                uploadFile(e.target.files);
              }}
              hidden
              multiple
            />
          </div>
        </div>
        <div className="flex justify-end space-x-2 mt-2 my-4">
          <button
            type="button"
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600 cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              if (tempPageName === "bookings") {
                dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
              }
              navigate("/booking/overview");
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white cursor-pointer"
          >
            Next
          </button>
        </div>
      </form>
      <Loader modalOpen={loaderOpen} />
    </div>
  );
}

export default CreateBooking;
